import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getLS } from '../helpers/utils';

class AlacrityDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '-1',
      options: [],
      img: '',
      label: '',
    };
  }

  componentDidMount() {
    this.setState({
      // eslint-disable-next-line react/destructuring-assignment
      options: this.props.renderOptionCustomized
        // eslint-disable-next-line react/destructuring-assignment
        ? this.props.options
        // eslint-disable-next-line react/destructuring-assignment
        : Object.entries(this.props.options),
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.iLang) {
      this.setState({ options: Object.entries(nextProps.options) });
    }

    // eslint-disable-next-line react/destructuring-assignment
    if (this.props.renderOptionCustomized && (this.props.options !== nextProps.options)) {
      if (nextProps.options.length === 1) {
        this.setState({
          options: nextProps.options,
          value: nextProps.options[0].value,
          label: nextProps.options[0].label,
          img: nextProps.options[0].img,
        });

        // eslint-disable-next-line react/destructuring-assignment
        this.props.onChange(nextProps.options[0].value);
      } else {
        this.setState({ options: nextProps.options, value: '-1' });
      }
    }
  }

  onChange(e, img, lbl) {
    const val = e.target ? e.target.value : e;
    const imgVal = img || '';
    const lblVal = lbl || '';

    this.setState({
      value: val,
      img: imgVal,
      label: lblVal,
    });
    // eslint-disable-next-line react/destructuring-assignment
    this.props.onChange(val, this.props.filterAttribute);
  }

  clearSelection() {
    this.setState({ value: '-1' });
  }

  render() {
    // eslint-disable-next-line react/destructuring-assignment
    const optionItems = this.state.options.map((option) => <option key={option[0]} value={option[0]}>{option[1]}</option>);

    // eslint-disable-next-line react/destructuring-assignment
    const optionCustomizedItems = this.state.options.map((item, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <option key={i} value={item.value}>
        {item.label}
      </option>
    ));

    // eslint-disable-next-line react/destructuring-assignment
    const optionsBtnDropDown = this.state.options.map((item, i) => (
      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events,react/jsx-key
      <li className="dropdown-item" onClick={() => this.onChange(`${item.value}`, `${item.img}`, `${item.label}`)}>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img
          src={item.img}
          width="24px"
        />
        {' '}
        {item.label}
      </li>
    ));

    const { className, btnDropDown,t,id,title,renderOptionCustomized } = this.props;
    const { value } = this.state;

    const isDark = getLS('dark') === 'true';
    const base = className ? 'icon-menu form-control' : 'filter text-filter form-control';
    const finalClass = isDark ? `${base} form-control-dark` : base;

    return (
      <div className="form-group">
        {btnDropDown && (
          <div className="dropdown">
            <button
              className={className}
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {/* eslint-disable-next-line react/destructuring-assignment */}
              {this.state.value && this.state.value !== '-1' ? (
                <>
                  {/* eslint-disable-next-line react/destructuring-assignment */}
                  <img alt="" src={this.state.img} width="24px" />
                  {' '}
                  {/* eslint-disable-next-line react/destructuring-assignment */}
                  {this.state.label}
                </>
                // eslint-disable-next-line react/destructuring-assignment,react/jsx-no-comment-textnodes
              ) :  <span style={{ color: '#999' }}>
                {/* eslint-disable-next-line react/destructuring-assignment */}
                {t ? t('dropdown.filter-by') : ''} {this.props.title}
              </span>}
            </button>
            <ul
              className="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
            >
              {optionsBtnDropDown}
            </ul>
          </div>
        )}


        {!btnDropDown && (
          <select
            value={value}
            size="20px"
            id={id}
            onChange={this.onChange.bind(this)}
            className={finalClass}
          >
            <option value="-1">
              {t ? t('dropdown.filter-by') : null}
              {' '}
              {title}
            </option>
            {renderOptionCustomized ? optionCustomizedItems : optionItems}
          </select>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export { AlacrityDropdown };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AlacrityDropdown));
